export default __webpack_public_path__ + "static/media/delete-white.2abfbebf.svg";